import React, { FC } from 'react';

import cx from 'classnames';
import { getContrastingColor } from 'utils/getContrastingColor';

import { Settings, LandingMenuSnippetPage } from 'lib/sanity/types';

import CaseStudyGridItemSkeleton from 'atoms/CaseStudyGridItemSkeleton';

import { CaseStudyTileCount, RouteBasePaths } from 'constants/values';

import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from 'tailwind.config.js';

const tailwindSettings = resolveConfig(tailwindConfig);

export type LandingTabProps = {
  index: number;
  landingMenuSnippetPage: LandingMenuSnippetPage;
  selectedIndex: number | null;
  isFromCaseStudy?: boolean;
};

const LandingTabSkeleton: FC<LandingTabProps> = ({
  landingMenuSnippetPage,
  index,
  selectedIndex,
  isFromCaseStudy,
}) => {
  const currentTabIsActive = selectedIndex === index;
  const { title } = landingMenuSnippetPage;
  const backgroundColor = landingMenuSnippetPage.background;
  const contrastingColor = getContrastingColor(
    backgroundColor,
    (tailwindSettings.theme.colors as any).white || '#ffffff',
    (tailwindSettings.theme.colors as any).black || '#181818',
  );
  return (
    <div
      style={{
        zIndex: index,
        backgroundColor: backgroundColor,
        color: contrastingColor,
      }}
      className={cx('LandingTab overflow-y-hidden shadow-tab relative', {
        'grow': !selectedIndex,
        'grow h-full overflow-y-scroll': currentTabIsActive,
        'opacity-0':
          currentTabIsActive &&
          !isFromCaseStudy &&
          !(landingMenuSnippetPage.slug === RouteBasePaths.WORK),
        'grow h-tab hover-supported:hover:h-tab-hovered shrink-0':
          !currentTabIsActive,
      })}
    >
      <div
        className="sticky top-0 flex w-full h-tab px-content-skinny tablet:px-content-narrow items-center z-nav pointer-events-none"
        style={{
          backgroundImage:
            backgroundColor &&
            `linear-gradient(180deg, ${backgroundColor} 50%, ${backgroundColor}00 100%)`,
        }}
      >
        <div
          style={{
            backgroundColor: `${backgroundColor}B3`,
          }}
          className="py-1 px-2 rounded-full backdrop-blur-xl -translate-x-2"
        >
          <h2 className="font-book">{title}</h2>
        </div>
      </div>
      <article className="relative w-full">
        {currentTabIsActive && (
          <div className={cx('absolute top-0 left-0 w-full z-loading')}>
            <div className="grid grid-cols-1 tablet:grid-cols-2 gap-10 tablet:gap-6 px-6 w-full">
              {[...Array(CaseStudyTileCount)].map(() => {
                return <CaseStudyGridItemSkeleton />;
              })}
            </div>
          </div>
        )}
      </article>
    </div>
  );
};

export default LandingTabSkeleton;
